<template>
  <modal name="delivery-invoice-modal" height="auto" width="880px" style="margin-top: 40px;" :scrollable="true" :shiftY="0.2">
    <div class="close">
      <img class="hover_btn" src="../../assets/icons/close.svg" @click="close()"  alt="">
    </div>
    <div class="modal-form">
      <iframe width="100%" height="500px" :src="file" frameborder="0"></iframe>
    </div>
  </modal>
</template>

<script>


export default {
  name: "delivery-invoice-modal",
  components: {},
  data: ()=> ({
    file: ''
  }),
  methods: {
    open(data){
      if (data) {
        this.file = 'data:application/pdf;base64,' + data;
        this.$modal.show('delivery-invoice-modal');
      }
    },
    close() {
      this.$modal.hide('delivery-invoice-modal');
    },
  }
}
</script>

<style scoped lang="scss">

.progress-bar-container {
  width: 140px;
  margin: 0px auto;
}

.order-info {
  font-size: 14px;
  margin-right: 10px;
}

.btn{
  width: 100%;
  padding: 0;
  button{
    width: 100%;
    height: 50px;
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #FFFFFF;
    background: #2CB181;
    border-radius: 4px;
    border: none;
  }
}
.modal-form {
  padding: 30px;
}
.input-block {
  margin-bottom: 15px;
}
h4{
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
  color: #000000;
  margin: 0 0 5px 1px;
  &.add{
    display: flex;
    justify-content: space-between;
    a{
      font-family: Roboto;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 16px;
      text-align: right;
      text-decoration-line: underline;
      color: #7A818F;
    }
  }
}
input{
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #7A818F;
  padding-left: 10px;
  width: 100%;
  height: 40px;
  background: #FFFFFF;
  border: 1px solid #EEF0F3;
  box-sizing: border-box;
  border-radius: 4px;
  &.about{
    height: 117px;
  }
  &:disabled{
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 14px;
    color: #7A818F;
    background: #EEF0F3;
  }
}
</style>
